import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import AgencyFavicon from '../../assets/fav/agency_favicon.ico';
import AgentFavicon from '../../assets/fav/agent_favicon.ico';

import favicon from '../../assets/fav/favicon.ico';



import AgentLogo from '../../assets/images/logo_agent.png';
import AgencyLogo from '../../assets/images/logo_agency.png';
import Logo from '../../assets/images/logo.png';


export default function SEO({ title, description, name, type }) {
    const screenType = window.location.pathname.split('/')[1]


    const data = useMemo(() => {
        switch (screenType) {
            case 'agency':
                return {
                    title: "FAME.Live Agency",
                    description: "Manage your agency and creators with FAME.Live for Agency",
                    name: "FAME.Live",
                    type: "website",
                    favicon: AgencyFavicon,
                    logo: AgencyLogo,
                    url: window.location.origin + "/agency/login"
                }
            case 'agent':
                return {
                    title: "FAME.Live Agent",
                    description: "Manage your creators with FAME.Live for Agent",
                    name: "FAME.Live",
                    type: "website",
                    favicon: AgentFavicon,
                    logo: AgentLogo,
                    url: window.location.origin + "/agent/login"
                }
            default:
                return {
                    title: "FAME.Live",
                    description: "Manage your creators with FAME.Live",
                    name: "FAME.Live",
                    type: "website",
                    favicon: favicon,
                    logo: Logo,
                    url: window.location.origin + "/login"
                }
        }
    }, [screenType])

    return (
        <Helmet>
            <link rel="icon" href={data?.favicon} />
            {/* <link rel="icon" type="image/png" href="../../public/agency_favicon.ico" sizes="16x16" /> */}

            { /* Standard metadata tags */}
            <title>{title ?? data?.title}</title>
            <meta name='description' content={description ?? data?.description} />
            { /* End standard metadata tags */}


            {/* Open Graph metadata */}
            <meta property="og:type" content={data?.type} />
            <meta property="og:title" content={data?.title} />
            <meta property="og:description" content={data?.description} />
            <meta property="og:url" content={data?.url} />
            <meta property="og:image" content={data?.logo} />

            { /* Facebook tags */}
            <meta property="og:type" content={type ?? data?.type} />
            <meta property="og:title" content={title ?? data?.title} />
            <meta property="og:description" content={description ?? data?.description} />
            { /* End Facebook tags */}
            { /* Twitter tags */}
            <meta name="twitter:creator" content={name ?? data?.name} />
            <meta name="twitter:card" content={type ?? data?.type} />
            <meta name="twitter:title" content={title ?? data?.title} />
            <meta name="twitter:description" content={description ?? data?.description} />
            { /* End Twitter tags */}
        </Helmet>
    )
}
